import PAYMENTS, { CheckoutRoutesTypes } from '@routes/path/payments'

export const isCheckoutRoute = (path: string): path is CheckoutRoutesTypes => {
  const checkoutPaths = Object.values(PAYMENTS.CHECKOUT)

  return checkoutPaths.includes(path as CheckoutRoutesTypes)
}
